<template>
  <div>
    <v-row>
      <v-col>
        <h2>Редактирование страницы "{{ pageItem.name }}"</h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-form ref="form" lazy-validation v-model="valid">
          <v-row dense>
            <v-col>
              <!--<editor
                api-key="no-api-key"
                v-model="pageItem.content"
                :init="{
                  toolbar_mode: 'sliding',
                  plugins:
                    'anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
                  toolbar:
                    'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat',
                }"
              />-->
              <textarea  v-model="pageItem.content" id="pageItemContent"></textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn color="primary" @click="update" :disabled="isLoading">
                Сохранить
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>
  </div>
</template>

<script>

import Editor from "@tinymce/tinymce-vue";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
const ContentPageRepository = RepositoryFactory.get("contentPage");
export default {
  components: {
    /*editor: Editor,*/
  },

  data() {
    return {
      valid: true,
      isLoading: false,
      pageItem: {
        id: 0,
        name: "Новая страница",
        content: "Содержимое страницы",
        pageType: 0,
      },
    };
  },
  mounted() {
    this.get();
    console.log(window.tinymce);
    window.tinymce.init({
        selector: "#pageItemContent",
        plugins: "anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount",
        toolbar: "undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat",
        license_key: "gpl"
    });
  },
  methods: {
    async get() {
      this.isLoading = true;
      const result = await ContentPageRepository.get(this.$route.params.id);
      if (result) {
        if (result.data.status === "success") {
          this.pageItem = result.data.data;
        }
      }
      this.isLoading = false;
    },
    async update() {
      this.isLoading = true;
      const result = await ContentPageRepository.update(this.pageItem);

      this.isLoading = false;
    },
  },
};
</script>
